import {environment} from '../../../environments/environment';
import {Injectable} from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ImageService {
  private readonly imageFolder: string = environment.bucketconfig.bucketFolderToSavePhotos;
  private readonly defaultImageName: string = 'imageNotAvailable';

  constructor() { }

  private getBucketUrl(): string {
    const { bucketName } = environment.bucketconfig;
    return `https://s3-sa-east-1.amazonaws.com/${bucketName}/${this.imageFolder}`;
  }

  getUrlFirstElement(photos: string): string {
    const url = this.getBucketUrl();
    const photo = photos ? photos.split(';')[0] : this.defaultImageName;
    return `${url}${photo}`;
  }

  makeUrl(photo: string): string {
    return `${this.getBucketUrl()}${photo}`;
  }

  parsePhotoArray(photos: string): string[] {
    return photos ? photos.split(';') : ['imageNotAvailable'];
  }
}
